import React from 'react';
import PropTypes from 'prop-types';
import AuthenticatedUserView from 'refactored/ui/views/authenticatedUserView';

import PaymentDataContainer from 'components/PaymentData';

const PaymentData = ({ className, handleBack }) => (
  <AuthenticatedUserView className={className} handleBack={handleBack}>
    <section className="main" role="main">
      <PaymentDataContainer />
    </section>
  </AuthenticatedUserView>
);

PaymentData.propTypes = {
  className: PropTypes.string,
  handleBack: PropTypes.func.isRequired,
};

PaymentData.defaultProps = {
  className: '',
};

export default PaymentData;
